import { Button } from './Button'
import { withButton } from './withButton'

const ConnectedButton = withButton(Button)

export { ConnectedButton as Button }
